import { SharedConstants } from "../../../../shared/constants/shared.constants";
export class EditMobileConfigConstants {
    static ERROR_OBJECT_NAME = "Update mobile configuration";
    static MIN_APP_VERSION_FORM_CONTROL = "minAppVersion";
    static MIN_APP_VERSION_TEXT_PLACEHOLDER = "Minimum app version";
    static MOBILE_CONFIG_UPDATED_MSG = "Mobile Configuration updated";
    static MAX_OFFLINE_HOURS_FORM_CONTROL = "maxOfflineHours";
    static MAX_OFFLINE_HOURS_TEXT_PLACEHOLDER = "Max offline hours";
    static ALLOW_OFFLINE_ACCESS_FORM_CONTROL = "allowOfflineAccess";
    static ALLOW_OFFLINE_ACCESS_TEXT_PLACEHOLDER = "Allow offline access";
    static OBJECT_NAME = "Mobile configuration";
    static CANCEL_BUTTON_LABEL = "Cancel";
    static ADD_BUTTON_LABEL = "Add";
}
export const FormError = {
    minAppVersion: "",
    maxOfflineHours: "",
    allowOfflineAccess: "",
};
export const ValidationMessage = {
    minAppVersion: {
        required: `minAppVersion ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
        maxlength: `minAppVersion ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "150")}`,
        pattern: "minAppVersion should be in the following format: e.g 1.1.1 "
    },
    maxOfflineHours: {
        required: `maxOfflineHours ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION.replace(".", "")} and must be numeric.`,
        maxlength: `maxOfflineHours ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "150")}`,
    },
    allowOfflineAccess: {
        required: `allowOfflineAccess ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
        maxlength: `allowOfflineAccess ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "100")}`,
    }
};
